import ApiHelper from "../../utils/apiHelper";
import { PlatformType } from "../../utils/helpers/subdomainHelpers/getPlatformType";
import { globalActionCreators, selectApiBaseUrl } from "./globalModule";

// TODO: Set to false (or remove the mock block below) when /v1/info/ backend is ready
const USE_MOCK_TENANT_INFO_FOR_AIRLINE = false;

const MOCK_TENANT_INFO_RESPONSE = {
  name: "Swiss Airline",
  domain: "swiss.airline",
  style: {
    logo: "https://d1o0qt6ld1319s.cloudfront.net/dev/3f20be5d-0559-48ff-b095-8e6ffa8741f2/1b3466d279965b1.svg",
    landing_image: "https://d1o0qt6ld1319s.cloudfront.net/dev/3f20be5d-0559-48ff-b095-8e6ffa8741f2/3d980753dfa113a.png",
    button: {
      color: "#7EAC55",
      hover: "#7EAC55",
      click: "#7EAC55",
      active: "#7EAC55"
    },
    page: {
      main_color: "#EDEDED",
      box_color: "#EFEFEF"
    }
  },
  links: [
    {
      name: "footer_about",
      label: "About",
      links: [
        {
          label: "How does it work?",
          link: "http://howdoesitwork.com",
          icon: null
        },
        {
          label: "FAQ\u0027s",
          link: "http://faq.com",
          icon: null
        },
        {
          label: "Contact \u0026 Support",
          link: "http://contact.com",
          icon: null
        }
      ]
    },
    {
      name: "footer_legal",
      label: "Legal",
      links: [
        {
          label: "Privacy Policy",
          link: "http://privacy.com",
          icon: null
        },
        {
          label: "Imprint",
          link: "http://imprint.com",
          icon: null
        },
        {
          label: "Terms \u0026 Conditions",
          link: "http://terms.com",
          icon: null
        }
      ]
    }
  ]
};

export const tenantActionTypes = {
  SET_TENANT_INFO: "SET_TENANT_INFO",
  TOGGLE_TENANT_CODE_ERROR: "TOGGLE_TENANT_CODE_ERROR",
  TOGGLE_TENANT_INFO_LOADER: "TOGGLE_TENANT_INFO_LOADER"
};

export const initialState = {
  tenantInfo: null,
  noTenantCodeError: false,
  isLoadingTenantInfo: false
};

const tenantModule = (state = initialState, action: any) => {
  switch (action.type) {
    case tenantActionTypes.SET_TENANT_INFO:
      return {
        ...state,
        tenantInfo: action.tenantInfo
      };
    case tenantActionTypes.TOGGLE_TENANT_INFO_LOADER:
      return {
        ...state,
        isLoadingTenantInfo: action.isLoadingTenantInfo
      };
    case tenantActionTypes.TOGGLE_TENANT_CODE_ERROR:
      return {
        ...state,
        noTenantCodeError: action.noTenantCodeError
      };

    default:
      return state;
  }
};

export default tenantModule;

function getTenantInfoUrl(apiUrl: string, codeOrUrl: string, platformType: PlatformType): string {
  if (platformType === "airline") {
    return `${apiUrl}/v1/info/${codeOrUrl}`;
  }
  return `${apiUrl}/hotel/info/${codeOrUrl}`;
}

export const tenantActionCreators = {
  getTenantInfoAction:
    (codeOrUrl: string, isInitialPageLoad: boolean, navigate: any) => async (dispatch: any, getState: any) => {
      const apiUrl = selectApiBaseUrl(getState());
      if (!apiUrl) {
        return;
      }
      const platformType = getState().global.platformType as PlatformType;
      const url = getTenantInfoUrl(apiUrl, codeOrUrl, platformType);
      const language = localStorage.getItem("i18nextLng");

      dispatch(globalActionCreators.clearAppErrorAction());

      dispatch({
        type: tenantActionTypes.TOGGLE_TENANT_INFO_LOADER,
        isLoadingTenantInfo: true
      });

      try {
        // Mock for airline until /v1/info/ is implemented – remove this block when backend is ready
        if (USE_MOCK_TENANT_INFO_FOR_AIRLINE && platformType === "airline") {
          await new Promise(resolve => setTimeout(resolve, 300));
          const mockData = MOCK_TENANT_INFO_RESPONSE;
          dispatch({
            type: tenantActionTypes.SET_TENANT_INFO,
            tenantInfo: mockData
          });
          if (!isInitialPageLoad) {
            window.location.hostname = `${mockData.domain}/${language}`;
          }
        } else {
          const response = await ApiHelper.get(url);
          dispatch({
            type: tenantActionTypes.SET_TENANT_INFO,
            tenantInfo: response.data
          });
          if (!isInitialPageLoad) {
            window.location.hostname = `${response.data.domain}/${language}`;
          }
        }
      } catch (err: any) {
        if (isInitialPageLoad) {
          dispatch(
            globalActionCreators.setAppErrorAction({
              status: err?.response?.status ?? null,
              goToMainDomain: true
            })
          );
        }
        dispatch({
          type: tenantActionTypes.TOGGLE_TENANT_CODE_ERROR,
          noTenantCodeError: true
        });
      } finally {
        dispatch({
          type: tenantActionTypes.TOGGLE_TENANT_INFO_LOADER,
          isLoadingTenantInfo: false
        });
      }
    }
};
